import script from "./teamOverviewV2.vue?vue&type=script&setup=true&lang=js"
export * from "./teamOverviewV2.vue?vue&type=script&setup=true&lang=js"

import "./teamOverviewV2.vue?vue&type=style&index=0&id=51d5bba4&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d5bba4"]])

export default __exports__